import { render, staticRenderFns } from "./MyWish.vue?vue&type=template&id=1c1e5c7e&scoped=true&"
import script from "./MyWish.vue?vue&type=script&lang=js&"
export * from "./MyWish.vue?vue&type=script&lang=js&"
import style0 from "./MyWish.vue?vue&type=style&index=0&id=1c1e5c7e&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1c1e5c7e",
  null
  
)

export default component.exports